import { render, staticRenderFns, recyclableRender, components } from "./u-checkbox-group.vue?vue&type=template&id=2ef8bac9&scoped=true&"
var renderjs
import script from "./u-checkbox-group.vue?vue&type=script&lang=js&"
export * from "./u-checkbox-group.vue?vue&type=script&lang=js&"
import style0 from "./u-checkbox-group.vue?vue&type=style&index=0&id=2ef8bac9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../HBuilderX.3.8.4.20230531/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef8bac9",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-checkbox-group/u-checkbox-group.vue"
export default component.exports